'use client';

import React, { useEffect, useState } from 'react';
import '../lang/i18n';
import { getI18n, I18nextProvider } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';

export const TranslatorProvider = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth();
    const language = user?.language || 'en';
    const [currentLanguage, setCurrentLanguage] = useState(language);

    useEffect(() => {
        const i18n = getI18n();
        if (language && language !== currentLanguage) {
            console.log("Updating language to:", language);
            i18n.changeLanguage(language);
            setCurrentLanguage(language);
        }
    }, [language, currentLanguage]);

    return (
        <I18nextProvider i18n={getI18n()}>
            {children}
        </I18nextProvider>
    );
};